// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json'; // 英文翻译文件
import zhTranslation from './locales/zh/translation.json'; // 中文翻译文件
import twTranslation from './locales/tw/translation.json';

// 配置i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
      tw: {
        translation: twTranslation,
      }
    },
    lng: 'zh', // 设置默认语言
    fallbackLng: 'zh', // 设置备选语言（当请求的语言不可用时）
    interpolation: {
      escapeValue: false, // 如果你在翻译文本中使用了HTML，请设置为false
    },
  });

export default i18n;